import LegalNotice from './legalNotice';
import { ILegalNotice } from './iLegalNotice';

export type { ILegalNotice };
export default LegalNotice;
